import { createContext } from 'react';

const SmartbannerContext = createContext({
  isSmartbannerActive: false,
  setIsSmartbannerActive: () => {}
});

export default SmartbannerContext;
